import { useChatBot } from "../../libs/use-chatbot";
import { FaArrowRight, FaBars } from 'react-icons/fa';
import './chatbot.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CustomButton } from "../../components/button/custom-button";
import { TextBubble } from "../../components/text-bubble/text-bubble";
import { Box, IconButton, SwipeableDrawer, TextareaAutosize } from "@mui/material";
import { Textarea } from '@mui/joy';
import Sidebar from "../../components/sidebar/sidebar";
import { useEffect, useState } from "react";
import { getDarkMode, getResponseType, initNewSessionId, saveResponseType, setDarkMode } from "../../libs/common/storage";
import { ThemeSwitch } from "../../components/switch/theme-switch";
import { DarkMode, LightMode } from "@mui/icons-material";
import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import { isMobile } from "react-device-detect";


export const ChatBot = () => {
    const {
        messages,
        input,
        setInput,
        sendMessage,
        isTyping,
        copyToClipboard,
        updateTyping,
        deleteMessage,
        messagesEndRef,
        clearMessages,
        regenerateAnswer,
        themeMode,
        toggleDarkMode
    } = useChatBot();
    const [themeClass, setThemeClass] = useState<string>("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [showBurger, setShowBurger] = useState(false);

    useEffect(() => {
        if (isMobile) {
            setShowBurger(true);
        }
        initNewSessionId();
        saveResponseType(getResponseType());
    }, [])

    useEffect(() => {
        if (isMobile) {
            if (!sidebarOpen) {
                setTimeout(() => setShowBurger(true), 400);
            } else {
                setShowBurger(false);
            }
        }
    }, [sidebarOpen])


    useEffect(() => {
        console.log('isMobile:', isMobile, 'sidebarOpen:', sidebarOpen);
        setDarkMode(getDarkMode());
        setThemeClass(themeMode ? "dark-bg" : "light-bg");
    }, [themeMode]);

    const DisplayTyping = () => {
        return isTyping && (
            <div className="d-flex justify-content-start mb-3">
                <div className={`p-2 ${themeMode ? "" : "border bg-light"} rounded text-black typing-animation`}>
                    <span style={{ color: themeMode ? "white" : "black" }}>Thinking  &nbsp;</span>
                    <span className="dot small-dot"></span>
                    <span className="dot small-dot"></span>
                    <span className="dot small-dot"></span>
                </div>
            </div>
        )
    }

    const DisplayReccomendedTexts = () => {
        return ["What are the air pollutants?", "What does EAD do?"].map(text => (
            <CustomButton
                key={text}
                btnSeverity="success"
                btnType={"outline"}
                onClick={() => { setInput(text); sendMessage(); }}
                hasText
                hasIcon={false}
                className="recommend-text"
                style={{
                    borderRadius: 8, marginRight: 15, marginTop: 10, color: themeMode ? "white" : "#80868E", fontSize: 18,
                    background: !themeMode ? "white" : ""
                }}
                text={text}
            />
        ));
    }




    const textAreaKeyDown = (e: any) => {
        if (e.key === "Enter") {
            e.preventDefault();
            sendMessage();
        }
    }
    const DisplayMobileText = () => {
        if (messages.length) {
            return (
                <Box className={`footer ${themeClass}`}   >
                    <div className="d-flex align-items-center" style={{}}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextareaAutosize
                                minRows={1}
                                maxRows={3}
                                placeholder="Message EAD"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        sendMessage();
                                    }
                                }}
                                className={`form-control pt-2 pb-2 ${themeMode ? 'textarea-dark' : ''}`}
                                style={{
                                    resize: 'none',
                                    width: '100%',
                                    padding: '8px 50px 8px 12px',
                                    borderRadius: 20,
                                    border: themeMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid #ccc',
                                    color: themeMode ? 'rgb(155 155 155)' : '#000',
                                    outline: 'none',
                                    boxShadow: themeMode ? '2px 1px 1px black' : '2px 1px 1px rgb(155 155 155)',
                                    background: themeMode ? 'rgb(38 42 46)' : 'white',
                                    fontSize: 16,
                                    lineHeight: 1.4,
                                }}
                                onFocus={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.6)'
                                        : '1px solid #999';
                                }}
                                onBlur={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.2)'
                                        : '1px solid #ccc';
                                }}
                            />

                            <CustomButton
                                btnSeverity="success"
                                btnType="filled"
                                onClick={sendMessage}
                                hasText={false}
                                text=""
                                className={` ${themeMode ? 'bg-white text-success' : 'light-btn'} btn btn-success send-btn d-flex align-items-center justify-content-center rounded-circle`}
                                style={{
                                    width: 40,
                                    height: 40,
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                }}
                                hasIcon
                                icon={<FaArrowRight />}
                            />
                        </div>
                            

                    </div>
                     
                </Box>
            )
        }
        return (
            <>
                <div className="center-vh" style={{ textAlign: 'center' }}>
                    <h2 className={`${themeMode ? "text-white" : ""}  mb-4 fw-medium title-text`}  > Welcome to EAD Chatbot! How may I assist you ?</h2>

                </div>
                <Box className={`footer ${themeClass}`}   >
                    <div className="d-flex align-items-center" style={{}}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextareaAutosize
                                minRows={1}
                                maxRows={3}
                                placeholder="Message EAD"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        sendMessage();
                                    }
                                }}
                                className={`form-control pt-2 pb-2 ${themeMode ? 'textarea-dark' : ''}`}
                                style={{
                                    resize: 'none',
                                    width: '100%',
                                    padding: '8px 50px 8px 12px',
                                    borderRadius: 20,
                                    border: themeMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid #ccc',
                                    color: themeMode ? 'rgb(155 155 155)' : '#000',
                                    outline: 'none',
                                    boxShadow: themeMode ? '2px 1px 1px black' : '2px 1px 1px rgb(155 155 155)',
                                    background: themeMode ? 'rgb(38 42 46)' : 'white',
                                    fontSize: 16,
                                    lineHeight: 1.4,
                                }}
                                onFocus={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.6)'
                                        : '1px solid #999';
                                }}
                                onBlur={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.2)'
                                        : '1px solid #ccc';
                                }}
                            />

                            <CustomButton
                                btnSeverity="success"
                                btnType="filled"
                                onClick={sendMessage}
                                hasText={false}
                                text=""
                                className={` ${themeMode ? 'bg-white text-success' : 'light-btn'} btn btn-success send-btn d-flex align-items-center justify-content-center rounded-circle`}
                                style={{
                                    width: 40,
                                    height: 40,
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                }}
                                hasIcon
                                icon={<FaArrowRight />}
                            />
                        </div>


                    </div>
                                
                </Box>

            </>

        )
    }

    const DisplayTextInput = () => {
        if (messages.length) {
            return (
                <Box className={`footer ${themeClass}`}   >
                    <div className="d-flex align-items-center" style={{}}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextareaAutosize
                                minRows={3}
                                maxRows={6}
                                placeholder="Message EAD"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        sendMessage();
                                    }
                                }}
                                className={`form-control pt-2 pb-2 ${themeMode ? 'textarea-dark' : ''}`}
                                style={{
                                    resize: 'none',
                                    width: '100%',
                                    padding: '8px 50px 8px 12px',
                                    borderRadius: 20,
                                    border: themeMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid #ccc',
                                    color: themeMode ? 'rgb(155 155 155)' : '#000',
                                    outline: 'none',
                                    boxShadow: themeMode ? '2px 1px 1px black' : '2px 1px 1px rgb(155 155 155)',
                                    background: themeMode ? 'rgb(38 42 46)' : 'white',
                                    fontSize: 16,
                                    lineHeight: 1.4,
                                }}
                                onFocus={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.6)'
                                        : '1px solid #999';
                                }}
                                onBlur={(e) => {
                                    e.target.style.border = themeMode
                                        ? '1px solid rgba(255,255,255,0.2)'
                                        : '1px solid #ccc';
                                }}
                            />

                            <CustomButton
                                btnSeverity="success"
                                btnType="filled"
                                onClick={sendMessage}
                                hasText={false}
                                text=""
                                className={` ${themeMode ? 'bg-white text-success' : 'light-btn'} btn btn-success send-btn d-flex align-items-center justify-content-center rounded-circle`}
                                style={{
                                    width: 40,
                                    height: 40,
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                }}
                                hasIcon
                                icon={<FaArrowRight />}
                            />
                        </div>


                    </div>
                </Box>
            )
        }
        return (
            <div className="center-vh" style={{ textAlign: 'center' }}>
                <h2 className={`${themeMode ? "text-white" : ""}  mb-4 fw-medium title-text`}  > Welcome to EAD Chatbot! How may I assist you ?</h2>
                <div className="input-group mb-3">
                    <div style={{ position: 'relative', width: '100%' }}>
                        <TextareaAutosize
                            minRows={3}
                            maxRows={6}
                            placeholder="Message EAD"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    sendMessage();
                                }
                            }}
                            className={`form-control pt-2 pb-2 ${themeMode ? 'textarea-dark' : ''}`}
                            style={{
                                resize: 'none',
                                width: '100%',
                                padding: '8px 50px 8px 12px',
                                borderRadius: 20,
                                border: themeMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid #ccc',
                                color: themeMode ? 'rgb(155 155 155)' : '#000',
                                outline: 'none',
                                boxShadow: themeMode ? '2px 1px 1px black' : '2px 1px 1px rgb(155 155 155)',
                                background: themeMode ? 'rgb(38 42 46)' : 'white',
                                fontSize: 16,
                                lineHeight: 1.4,
                            }}
                            onFocus={(e) => {
                                e.target.style.border = themeMode
                                    ? '1px solid rgba(255,255,255,0.6)'
                                    : '1px solid #999';
                            }}
                            onBlur={(e) => {
                                e.target.style.border = themeMode
                                    ? '1px solid rgba(255,255,255,0.2)'
                                    : '1px solid #ccc';
                            }}
                        />

                        <CustomButton
                            btnSeverity="success"
                            btnType="filled"
                            onClick={sendMessage}
                            hasText={false}
                            text=""
                            className={` ${themeMode ? 'bg-white text-success' : 'light-btn'} btn btn-success send-btn d-flex align-items-center justify-content-center rounded-circle`}
                            style={{
                                width: 40,
                                height: 40,
                                position: 'absolute',
                                bottom: 8,
                                right: 8,
                            }}
                            hasIcon
                            icon={<FaArrowRight />}
                        />
                    </div>
                </div>
                {DisplayReccomendedTexts()}
            </div>
        )
    }

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', maxHeight: '100dvh', overflow: 'hidden' }}>

            {isMobile ? (
                <>
                    {showBurger && (
                        <IconButton
                            aria-label="Open menu"
                            onClick={() => setSidebarOpen(true)}
                            size="large"
                            disableRipple
                            sx={{
                                position: 'fixed',
                                top: 16,
                                left: 16,
                                zIndex: 1500,
                                background: 'transparent',
                                boxShadow: 'none',
                                padding: '6px',
                                '&:hover': { background: 'transparent' }
                            }}
                        >
                            <FaBars color={themeMode ? 'white' : '#004B87'} />
                        </IconButton>
                    )}

                    {/* Swipeable/mobile drawer */}
                    <SwipeableDrawer
                        anchor="left"
                        open={sidebarOpen}
                        onClose={() => setSidebarOpen(false)}
                        onOpen={() => setSidebarOpen(true)}
                        ModalProps={{ keepMounted: true }}
                        swipeAreaWidth={28}
                        disableBackdropTransition={false}
                        disableDiscovery={false}
                        PaperProps={{
                            sx: {
                                width: 380,
                                maxWidth: '80vw',
                                zIndex: 1400,
                                '--SideNavigation-slideIn': 1,
                                bgcolor: themeMode ? 'rgb(33,37,41)' : '#ffffff',
                                color: themeMode ? '#ffffff' : '#000000',
                                p: 1,
                                overflowY: 'auto',
                                transform: 'none !important',
                                position: 'relative !important'
                            }
                        }}
                    >
                        {/* DEBUG: simple fallback to verify Drawer is visible.
          Remove this block once real Sidebar appears. */}
                        <div style={{ padding: 8, display: 'block' }}>
                            <div style={{ fontWeight: 700, marginBottom: 8 }}></div>
                        </div>

                        {/* Force normal layout for the Sidebar inside the drawer */}
                        <div
                            className="drawer-sidebar-wrapper"
                            style={{ position: 'relative', width: '100%', boxSizing: 'border-box' }}
                        >
                            <Sidebar clearMessages={clearMessages} themeMode={themeMode} setSidebarOpen={setSidebarOpen} onClose={() => setSidebarOpen(false)}
                            />
                        </div>
                    </SwipeableDrawer>
                </>
            ) : (
                <Sidebar clearMessages={clearMessages} setSidebarOpen={setSidebarOpen} themeMode={themeMode} />
            )}

            <Box
                component="main"
                className={`MainContent ${themeClass}`}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px',
                    top: '40px',
                    position: 'relative',
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    ...(!themeMode && {
                        backgroundImage: `url(${require('../../assets/imgs/png/bg-lite.png')})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }),
                }}
            >
                <Box
                    className={`d-flex align-items-center`}
                    sx={{
                        borderRadius: '20px 20px 0 0',
                        paddingBottom: '20px',

                    }}>
                    {/* <CustomButton
                                        hasText
                                        onClick={() => window.location.reload()}
                                        text="Reset Chat"
                                        btnSeverity="success"
                                        btnType="filled"
                                        icon={<FaSyncAlt />}
                                        hasIcon
                                    /> */}
                    <div className="theme-switch">
                        <ThemeSwitch checked={themeMode} onChange={toggleDarkMode} />
                    </div>
                </Box>



                {/* Chat Messages */}
                <Box sx={{ flex: 1, overflowY: 'auto', padding: '10px', paddingTop: '20px',marginTop: '80px' }} className={`${themeClass}`}>
                    <TextBubble
                        darkMode={themeMode}
                        setTyping={updateTyping}
                        deleteMessage={deleteMessage}
                        copyToClipboard={copyToClipboard}
                        regenerateAnswer={regenerateAnswer}
                        messages={messages} />
                    {DisplayTyping()}
                    <div ref={messagesEndRef} />
                </Box>

                {isMobile ? DisplayMobileText() : DisplayTextInput()}
            </Box>
        </Box >
    )
}
